<template>
  <div id="app" @scroll="handleScroll">
   <template v-if="headNum == 4">
      <div class="h5-cont">
        <router-view />
      </div>
    </template>
    <template v-else>
      <myHeaderTow></myHeaderTow>
      <div class="content-box">
        <router-view />
        <div class="footer"> 
          <div class='footer-top flc'>
            <span> 公司名称：{{logoUrlObj.companyName}} </span>
            <span class='ml10'> 公司地址：{{logoUrlObj.address}} </span>
          </div>
          <div class='footer-top flc'>
            <span> 联系电话：{{logoUrlObj.phone}} </span>
            <span class='ml10'> 备案号： <a>赣ICP备2024032590号</a> </span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import myHeaderTow from "@/components/myHeaderTow";
import {getEnterpriseGetUserLogo} from "@/api/pc";
export default {
  name: "App",
  data() {
    return {
      headNum: 1,
      logoUrlObj:{
        phone: "",
        companyName: "",
        address: "",
      }
    };
  },
  components: { myHeaderTow },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: "getPath",
  },
  created(){
    getEnterpriseGetUserLogo({}).then(res=>{
      sessionStorage.logoUrlObj = JSON.stringify(res.data);
      this.logoUrlObj = res.data;
      document.title = res.data.websiteName;
      let applyIndex = ["/projectIndex", "/applyIndex"];
      if(applyIndex.indexOf(this.$route.path)>-1){
        this.$store.dispatch("SET_LOGOIMGURL", res.data.memberLogo?res.data.memberLogo:require('@/assets/logon.png'));
      }else{
        this.$store.dispatch("SET_LOGOIMGURL", res.data.enterpriseLogo?res.data.enterpriseLogo:require('@/assets/logon.png'));
      }
      this.$store.dispatch("SET_OFFICIALACCOUNTS", res.data.pubLogo?res.data.pubLogo:'');
      this.setLinkIcon(res.data.tabs?res.data.tabs:require('@/assets/icon.png'));
    })
  },
  methods: {
    getPath() {
      let arr3 = ["/authenhfive",'/ifram', '/auth_result', '/login', '/register'];
      if (arr3.indexOf(this.$route.path) > -1) {
        this.headNum = 4;
      } else {
        this.headNum = 1;
      }
    },
    handleScroll(event) {
      this.$store.dispatch("SET_LEFTWIDTH", event.target.scrollLeft);
    },
    setLinkIcon(dataUrl) {
      let href = dataUrl;
      // 创建新的 link 标签
      var newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.type = "image/x-icon";
      newLink.href = href;
      // 获取并移除原有的 favicon link（如果有多个，可能需要更精确的选择器）
      var oldLinks = document.querySelectorAll('link[rel="icon"]');
      for (var i = 0; i < oldLinks.length; i++) {
        oldLinks[i].parentNode.removeChild(oldLinks[i]);
      }
      // 将新创建的 link 插入到 head 中
      document.head.appendChild(newLink);
    }
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  overflow: auto;
  background-color: #e8ecf3;
}
.footer{
  font-size: 12px;
  color: #fff;
  padding: 10px 0;
  background: #3A4A73;
  .footer-top{
    height:30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
.app-content {
  min-width: 1306px;
  margin: 0 auto;
  height: calc(100% - 50px);
  overflow-y: auto;
}
.h5-cont {
  width: 100%;
  height: 100%;
  // padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
}
.content-box,
.content-gr-box {
  width: 100%;
  height: calc(100% - 50px);
}
.content-box {
  height: calc(100% - 50px);
  min-width: 1400px;
  box-sizing: border-box;
  overflow-y: auto;
}
.content-gr-box {
  min-width: 1400px;
}
</style>
